import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { TEMPLATE_TYPES } from "features/templates/constants";
import type { TemplateType } from "features/templates/types";

import TemplateTypeIcon from "./TemplateTypeIcon";

export default function TemplateTypeSelection({
  allowedTypes,
  templateType,
  setTemplateType,
}: {
  allowedTypes: TemplateType[];
  templateType: TemplateType;
  setTemplateType: (type: TemplateType) => void;
}) {
  const { t } = useTranslation("enums");

  return (
    <div className="flex flex-col gap-y-3">
      {allowedTypes.map((type) => {
        const { label } = TEMPLATE_TYPES[type];
        const isSelected = type === templateType;

        return (
          <button
            className={clsx(
              "group flex gap-x-2 rounded-3xl border p-3 transition-colors",
              isSelected
                ? "border-purple-500 bg-purple-50"
                : "border-black-300 hover:bg-black-100",
            )}
            type="button"
            key={type}
            onClick={() => setTemplateType(type)}
            data-cy={type}
          >
            <TemplateTypeIcon type={type} isSelected={isSelected} />

            <div className="flex flex-col gap-y-0.5">
              <span className="text-left text-sm-bold">{label}</span>
              <p className="text-left text-xs-medium text-black-500">
                {t(`templateDescription.${type}`, {
                  ns: "templates",
                  templateType: type,
                })}
              </p>
            </div>
          </button>
        );
      })}
    </div>
  );
}
